// Companion/blocks/DocumentBlock.tsx
import { DocumentBlockBody } from './bodies/DocumentBlockBody/DocumentBlockBody';
import type { ChatDocumentBlockPayload } from '@/types/chatBlocks';

/**
 * A lecture document. No V1 serve tool emits one; it is here so a legacy
 * conversation started from a document restores with its source block, and so
 * document chat has a renderer waiting.
 */
const DocumentBlock = ({ payload }: { payload: ChatDocumentBlockPayload }) => (
  <DocumentBlockBody
    item={{
      lectureId: payload.lectureId,
      fileName: payload.fileName ?? '',
    }}
  />
);

export default DocumentBlock;
